<template>
  <div>
    <router-link to="/lux" id="nav-prev"></router-link>
  </div>
</template>

<script>
  export default {
    name: 'selection',
  };
</script>



// WEBPACK FOOTER //
// Selection.vue?b8d59c68